import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/engineering/")({
  loader: () => {
    throw redirect({ to: "/labs/research" });
  },
  component: () => null,
});
